import React from 'react';
import { useCategoryAnalysis } from './context/CategoryAnalysisContext';
import PlatformTabs from '../Common/PlatformTabs';
import { useAnalytics, ANALYTICS_EVENTS } from "../../analytics";
import './style/tabsSection.scss';

const TabsSection = () => {
  const { trackEvent } = useAnalytics();
  const { activeTab, setActiveTab, categoryFilters, activeKeyword } = useCategoryAnalysis();

  const filterPlatform = categoryFilters?.platform
    ? (Array.isArray(categoryFilters.platform) ? categoryFilters.platform[0] : categoryFilters.platform)
    : null;
  const effectiveActiveTab = filterPlatform || activeTab;

  const handleTabChange = (newTab) => {
    setActiveTab(newTab);
    trackEvent(ANALYTICS_EVENTS.FEATURE.CATEGORY_EXPLORER_PLATFORM_CHANGED, { platform: newTab, genre: activeKeyword });
  };

  return (
    <div className="analysis-tabs">
      <PlatformTabs activeTab={effectiveActiveTab} onChange={handleTabChange} variant="pill" />
    </div>
  )
};

export default TabsSection;
